<template>
    <div>
      <!-- 搜索 -->
      <div>
        <SearchInput @search="handleSearch"  @update-data="handleUpdate"  />
        <div v-if="isLoading">
      <p style="text-align: center;" >正在加载...</p>
    </div>
  <div>
    <SearchBut   
       @search-success="handleSearchSuccess" 
       @search-error="handleSearchError"
       :pageSize="pageSize"
       :currentPage="currentPage"
       ref="childComponent"
      @update-current-page="updateCurrentPage"
        />
  </div>
      </div>
      <h2 class="title" ref="title"></h2>
      <!-- 显示商品列表 -->
    <ul>
      <li v-for="product in products" :key="product.id">
        <router-link :to="`/product/${product.id}`"> 
          <img  v-lazy="JSON.parse(product.image)[0]" :alt="product.name" />
          <h4>{{ product.title }}</h4>
        </router-link>
        <div class="jy">
          <span class="price">价格：{{ product.price }}元</span>
          <span>页数：{{ product.num }}</span>
        </div>
      </li>
    </ul>
    <div class="page">
      <button 
      :disabled="currentPage === 1"   
      :class="{ disabled: currentPage === 1 }" 
      @click="changePage(currentPage - 1)"
      >上一页</button>
      <span>{{ currentPage }} / {{ totalPages }}</span>
      <button 
      :disabled="currentPage === totalPages" 
      :class="{ disabled: currentPage === totalPages }" 
      @click="changePage(currentPage + 1)"
      >下一页</button>
    </div>
  </div>
</template>

<script>
import { productsList ,searchProducts } from '@/api/product/index'
import SearchInput from '@/components/SearchInput.vue'; 
import SearchBut from '@/components/SearchBut.vue'; 
export default {
  name: 'contentHome',
  data() {
    return {
      products: [],      // 商品数据
      total: 0,          // 总商品数
      pageSize: 40,      // 每页显示的商品数量
      currentPage: 1,    // 当前页码
      isLoading: false,  // 加载状态
      scrollY: 0,
      ispage:'1',  //判断搜索功能 1表示默认搜索, 2输入框,3分类按钮
      keywords:"",
      is_active:1,
    }
  },
  components:{
    SearchInput,
    SearchBut,
  },
  created() {
    this.fetchProducts()  
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize); // 计算总页数
    }
  },
  methods: {

    // 输入框搜索初始化页码1
    handleUpdate(newData) {
      this.currentPage = newData; // 更新父组件数据
    },
     saveScrollPosition() {
            this.scrollY = window.scrollY;
        },
        restoreScrollPosition() {
             this.$nextTick(() => {
        window.scrollTo(0, this.scrollY); // 恢复到保存的位置
      });
        },
async fetchProducts() {
  try {
    const response = await productsList(this.currentPage, this.pageSize,this.is_active); // 传递当前页码和每页条数
    // console.log('商品列表接口响应:', response);

    if (response && response.status === 200) {
      this.products = response.data || []; // 确保数据存在
      this.total = response.total || 0;    // 确保总数存在
    } else {
      console.error('获取商品列表失败，返回的数据格式不正确');
      this.products = [];
      this.total = 0;
    }
  } catch (error) {
    console.error('获取商品列表失败:', error);
    this.products = [];
    this.total = 0;
  }
},
async handleSearch(keyword) {
  if (keyword.trim() === '') {
    // '搜索关键词为空，清空结果;
  this.ispage = "1",
  this.currentPage = 1,
    await this.fetchProducts(); // 调用 fetchProducts 获取初始商品列表
    return;
  }
  this.keywords = keyword.trim(),
console.log(keyword);

  this.ispage = "2",
  this.isLoading = true; // 开始加载
  try {
    const response = await searchProducts(this.keywords,this.currentPage,this.pageSize); // 调用后端接口
    // console.log('搜索接口响应:', response);
    this.total = response.total
    if (response && response.status === 200) {
      this.products = response.data || []; // 更新搜索结果

    } else {
      console.error('搜索失败，返回的数据格式不正确');
      this.products = [];
    }
  } catch (error) {
    console.error('搜索失败:', error);
    this.products = [];
  } finally {
    this.isLoading = false; // 停止加载
  }
},
    changePage(page) {
      // 检查页码是否有效
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;

      if(this.ispage === "1"){
        this.fetchProducts(); // 获取新页的数据

      }else if(this.ispage === "2"){
        this.$nextTick(() => {
       this.handleSearch( this.keywords)
      });
         console.log("搜索关键词:", this.keywords || "没有关键词");
        
      } else{
        this.$nextTick(() => {
          this.$refs.childComponent.triggerSearch();
});
      }


  window.scrollTo({
      top: 0,
    });
    },
 handleSearchSuccess(response) {
  this.ispage = "3",

      this.products =  response.result; // 更新父组件的搜索结果
        this.$refs.title.textContent = ''; 
        this.currentPage = response.currentPage;
        this.total = response.total;
    },
   
  // 更新 currentPage 的方法
  updateCurrentPage(page) {
      this.currentPage = page;
    },
    handleSearchError(error) {
      console.error('搜索发生错误：', error);
  this.$refs.title.textContent = '没有搜索到符合的商品~'; 
    }
  },

    beforeRouteLeave(to, from, next) {
    this.saveScrollPosition(); // 离开页面前保存滚动位置
    next();
  },
  activated() {
    this.restoreScrollPosition(); // 页面激活时恢复滚动位置
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.title{
  text-align: center;
  color: #f78d2b;
  font-weight: 400;
  font-size: 3.7vw;
  margin: 1vw;
}

ul {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

ul li h4 {
  display: block;
  width: 100%;
  height: 6vw; /* 高度使用vw */
  color: #fff;
  font-weight: 400;
  line-height: 6vw; /* 行高使用vw */
  background-color: #F99551;
  font-size: 3.7vw;
}

li {
  width: 44vw; /* 宽度使用vw */
  margin: 1.5vw; /* 外边距使用vw */
  text-align: center;
  position: relative;
  box-shadow: 0 0 8px #707070;
}

ul li .jy .price {
  color: #f8ea1d;
  list-style: none;
  padding-left: 0.5vw; /* 内边距使用vw */
}

ul li .jy span {
  color: #fff;
  padding-right: 0.5vw; /* 内边距使用vw */
}

.jy {
  width: 100%;
  height: 6vw; /* 高度使用vw */
  line-height: 6vw; /* 行高使用vw */
  display: flex;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  bottom: 6vw; /* 距离底部的高度使用vw */
  font-size: 2.7vw; /* 字体大小使用vw */
}

img {
    width: 44vw; /* 宽度使用vw */
  height: 48vw; /* 高度使用vw */
}

.page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3vw 0; /* 上下外边距使用vw */
  gap: 3vw;
}
.page span{
  font-size: 4vw;
}
.page button{
  background: linear-gradient(125deg, #f54940, #f9832d); /* 从亮红到深红的渐变 */
  border: none;
  padding: 1vw 3vw;
  border-radius: 2vw;
  color: #fff;
}
/* 禁用状态样式 */
.page button.disabled,
.page button:disabled {
  background: linear-gradient(125deg, #e8847e, #f2bb93); /* 从亮红到深红的渐变 */
  cursor: not-allowed;
  text-decoration: #a5a4a4 line-through;
}
</style>
